//	src/components/Login.jsx

import React, { useState } from 'react';
import { logInWithGoogle, logInWithEmail, resetPassword } from '../../firebase';
import './Login.css';

export default function Login({ onToggleView }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);
    
    try {
      await logInWithEmail(email, password);
    } catch (err) {
      console.error(err);
      setError('Invalid email or password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setError('Please enter your email address above to reset your password.');
      return;
    }
    try {
      setError('');
      setMessage('');
      await resetPassword(email);
      setMessage('Password reset email sent! Check your inbox.');
    } catch (err) {
      setError('Failed to send reset email. Please check your email address.');
    }
  };

  return (
    <div className="login-wrapper">
      
      {/* Left Pane: Feature Image (Hidden on Mobile) */}
      <div className="login-left-pane">
        <div className="pane-overlay">
          <h2>Welcome to GangaTricks</h2>
          <p>Access your personalized dashboard, track your learning progress, and explore our vast course catalog.</p>
        </div>
      </div>

      {/* Right Pane: Form Container */}
      <div className="login-right-pane">
        <div className="login-form-container">
          
          <div className="login-header">
            <img src="/assets/icon.gif" alt="Logo" className="login-logo" />
            <h1>Sign in</h1>
            <p>Welcome back! Please enter your details.</p>
          </div>

          {error && <div className="login-error-alert">{error}</div>}
          {message && <div className="login-success-alert" style={{color: 'green', fontSize: '14px', marginBottom: '10px'}}>{message}</div>}

          <form onSubmit={handleEmailLogin} className="login-form">
            <div className="input-group">
              <label htmlFor="email">E-mail Address *</label>
              <input 
                id="email"
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email" 
                required 
              />
            </div>
            
            <div className="input-group">
              <label htmlFor="password">Password *</label>
              <input 
                id="password"
                type="password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" 
                required 
              />
            </div>

            <div className="forgot-password">
              <button 
                type="button" 
                onClick={handleForgotPassword} 
                style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}
              >
                Forgot password?
              </button>
            </div>

            <button type="submit" className="btn-primary" disabled={isLoading}>
              {isLoading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          <div className="login-divider">
            <span>or continue with</span>
          </div>

          <button onClick={logInWithGoogle} className="btn-google" type="button">
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google Logo" />
            Continue with Google
          </button>

          <div className="login-footer">
            Don't have an account? <span onClick={onToggleView} style={{ color: '#2563eb', fontWeight: '600', cursor: 'pointer' }}>Sign Up!</span>
          </div>

        </div>
      </div>
    </div>
  );
}